// ─── AT Console Design Tokens — Navy × Neón ────────────────────────────────
// Chrome estructural: navy oscuro del launcher (#0f1923 family)
// Accent UI:          verde neón (HeSH) · ámbar (Pricing Committee)
// APPROVE:            verde neón · REJECT: rojo coral

export const AT_COLORS = {
  // Fondos y superficies — navy del launcher
  bg:           '#0b1118',
  surface:      '#0f1923',
  surface2:     '#162436',
  surface3:     '#1a2d40',
  border:       '#1e2d3d',
  borderLight:  '#2a3f55',

  // Accent UI — emerald (tabs HeSH, sliders, BPM, brand)
  teal:         '#10b981',
  tealDim:      'rgba(16, 185, 129, 0.10)',
  tealGlow:     'rgba(16, 185, 129, 0.24)',

  // Staging/diffs — orange (Pricing Committee)
  amber:        '#f97316',
  amberDim:     'rgba(249, 115, 22, 0.12)',

  // APPROVE — emerald
  green:        '#10b981',
  greenDim:     'rgba(16, 185, 129, 0.10)',

  // REJECT — rojo coral
  red:          '#ff4757',
  redDim:       'rgba(255, 71, 87, 0.12)',

  purple:       '#7c3aed',
  purpleDim:    'rgba(124, 58, 237, 0.12)',

  text:         '#f0f6fc',
  textMuted:    '#8ba3bc',
  textDim:      '#3a5068',
} as const;

export const AT_FONTS = {
  mono:    '"JetBrains Mono", "IBM Plex Mono", "Fira Mono", monospace',
  ui:      '"Inter", -apple-system, sans-serif',
} as const;

export const AT_SIZES = {
  bpmDisplay:  '3.5rem',
  bpmLabel:    '0.65rem',
  panelRadius: '12px',
  inputRadius: '8px',
} as const;

// Outcome → color mapping
export const OUTCOME_COLOR: Record<string, string> = {
  APPROVE: AT_COLORS.green,
  REJECT:  AT_COLORS.red,
  ADJUST:  AT_COLORS.amber,
};

export const OUTCOME_BG: Record<string, string> = {
  APPROVE: AT_COLORS.greenDim,
  REJECT:  AT_COLORS.redDim,
  ADJUST:  AT_COLORS.amberDim,
};

// Flow → label mapping
export const FLOW_LABEL: Record<string, string> = {
  pricing:     'Pricing',
  docs:        'Revisión docs',
  inventory:   'Inventario',
  aprobologia: 'Aprobología',
};

// Alert priority → color
export const ALERT_COLOR: Record<string, string> = {
  HIGH:   AT_COLORS.red,
  MEDIUM: AT_COLORS.amber,
  INFO:   AT_COLORS.teal,
};
